import React from "react";
import { Container } from "./styles";
import RevisorTab from "./components/RevisorTab";

export default function PLCom() {
  return (
    <Container>
      <div className="header-info">
        <div className="header-details">
          <h3>PLCom — Inventário e Apuração Fiscal</h3>
          <div className="header-meta">
            <span className="status-tag">Dados mock — fiel à planilha</span>
            <span className="update-tag">Apuração semanal por XMLs + espelho da aba Impostos</span>
          </div>
        </div>
      </div>

      <RevisorTab />
    </Container>
  );
}
